export const Role = {
  SuperAdmin: "super-admin",
  Admin: "admin",
  Adult: "adult",
};
